import { Injectable } from '@angular/core';
import { IconHelper } from './icon.helper';
import { DateHelper } from './date.helper';
import { FinancialHelper } from './financial.helper';
import { AddressHelper } from './address.helper';

@Injectable()
export class HelperService {
    public address:  AddressHelper;
    public date: DateHelper;
    public financial: FinancialHelper;
    public icon: IconHelper;

    /**
     * Construct a new layout service.
     *
     */
    constructor() {
        this.date = new DateHelper;
        this.icon = new IconHelper;
        this.financial = new FinancialHelper;
        this.address = new AddressHelper;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/helper.service.ts